// @flow
import React, { useCallback } from 'react';
import { DRAWER_KEYS, StatsItemsCard } from 'features/command-center/components/shared';
import { COMMAND_CENTER_BASE_URL } from 'features/command-center/constants';
import { useDrawerManager } from 'features/command-center/contexts';
import { getYTDActivityPlacementsSummary } from 'features/command-center/services';
import strings from 'strings';

import { formatStats } from './PlacementsStatsSummary.utils';

export const PlacementsStatsSummary = ({ requestParams, hasDrillDown }) => {
  const { openDrawer } = useDrawerManager();

  const cachedPromises = useCallback(() => {
    const drawerHandlers = hasDrillDown
      ? {
          totalPlacements: ({ url }) => {
            openDrawer({
              activeDrawer: DRAWER_KEYS.Placements,
              contentProps: { endpoint: `${COMMAND_CENTER_BASE_URL}${url}` }
            });
          },
          totalFallOffs: ({ url }) => {
            openDrawer({
              activeDrawer: DRAWER_KEYS.FallOffs,
              contentProps: { endpoint: `${COMMAND_CENTER_BASE_URL}${url}` }
            });
          }
        }
      : null;

    const { recruiter } = requestParams;
    const groupBy = recruiter ? 'recruiter' : 'team';
    return getYTDActivityPlacementsSummary({ ...requestParams, groupBy }).then(({ data }) =>
      formatStats({ data, drawerHandlers })
    );
  }, [hasDrillDown, openDrawer, requestParams]);

  return (
    <StatsItemsCard
      header={strings.commandCenter.activity.placementsStatsSummary.title}
      promise={cachedPromises}
      textAlign="center"
    />
  );
};
